import {
    FETCH_CARS,
    FETCH_CARS_SUCCESS,
    FETCH_CARS_FAILED,
    EDIT_CAR
  } from "../store/types";
  import store from '../store/store';
  import { firebase } from '../config/configureFirebase';
  import { patchUsersCacheUpsert } from './usersactions';
  import { get, update, set, child, remove, push } from "firebase/database";
  import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
  import AccessKey from '../other/AccessKey';
  import base64 from 'react-native-base64';

  // Sends a picked car image to the validate_car_image Cloud Function, which
  // runs Google Vision label detection and returns { isCar, threshold, labels }.
  // Two input shapes:
  //   - string            → { imageBase64 } (legacy: CarEditScreen hard-blocks
  //                         non-car uploads before they are stored)
  //   - { storagePath }   → { storagePath } (onboarding wizard: the photo is
  //                         already in Storage at cars/{carId}, so the server
  //                         downloads it itself instead of a base64 round trip —
  //                         halves the car-photo bytes on 3G)
  // Mirrors voiceactions.transcribeAudio (same web.app host + project Basic
  // auth). The server is the authority on the enable toggle + threshold; when
  // validation is disabled it returns { isCar: true } without calling Vision.
  export const validateCarImage = async (input) => {
    const { config } = firebase;
    let body;
    if (typeof input === 'string') {
      body = { imageBase64: input };
    } else if (input && input.storagePath) {
      body = { storagePath: input.storagePath };
    } else {
      throw new Error('validateCarImage: expected a base64 string or { storagePath }');
    }
    const url = `https://${config.projectId}.web.app/validate_car_image`;
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + base64.encode(config.projectId + ':' + AccessKey),
      },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const errBody = await res.text().catch(() => '');
      throw new Error(`Car image validation failed (${res.status}): ${errBody}`);
    }
    return await res.json();
  };

  export const fetchCars = () => async (dispatch) => {

    const {
        carsRef
    } = firebase;

    dispatch({
      type: FETCH_CARS,
      payload: null
    });

    const userInfo = store.getState().auth.profile;

    try {
      const snapshot = await get(carsRef(userInfo.uid, userInfo.usertype));
      if (snapshot.val()) {
        let data = snapshot.val();
        const arr = Object.keys(data).map(i => {
          data[i].id = i;
          return data[i]
        });
        dispatch({
          type: FETCH_CARS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_CARS_FAILED,
          payload: store.getState().languagedata.defaultLanguage.no_cars
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_CARS_FAILED,
        payload: error.message
      });
    }
  };
  
  export const editCar = (car, method) => async (dispatch) => {
    const {
      singleUserRef,
      carAddRef, 
      carEditRef,
      carImage
    } = firebase;
    dispatch({
      type: EDIT_CAR,
      payload: { method, car }
    });
    if (method === 'Add') {
        push(carAddRef, car);
    } else if (method === 'Delete') {
        remove(carEditRef(car.id));
    } else if (method === 'UpdateImage') {
      await uploadBytesResumable(carImage(car.id),car.car_image);
      let image = await getDownloadURL(carImage(car.id));
      let data = car;
      data.car_image = image;
      set(carEditRef(car.id), data);
      if(car.active && car.driver){
        const userPatch = {
          updateAt: new Date().getTime(),
          car_image: image
        };
        update(singleUserRef(car.driver), userPatch);
        // Keep the acting client's cached users array coherent so the new car
        // image shows after refresh (mirrors updateUserCar). Other admins /
        // mobile-driver uploads are covered by the live /users_slim listener.
        patchUsersCacheUpsert(car.driver, userPatch);
      }
    }
     else {
        set(carEditRef(car.id),car);
    }
  }

  export const updateUserCarWithImage = (newData, blob) => (dispatch) => {
    const {
      auth,
      carAddRef,
      singleUserRef,
      carImage
    } = firebase;

    var carId = push(carAddRef).key;

    // Return the chain (and await the writes) so callers can wait for the row
    // to actually land in /cars before refreshing the list / showing success.
    // Previously set()/update() were fire-and-forget, so the success alert and
    // goBack() fired before the write completed and the list stayed stale.
    return uploadBytesResumable(carImage(carId),blob).then(() => {
      blob.close()
      return getDownloadURL(carImage(carId))
    }).then(async (url) => {
      newData.car_image = url;
      await set(child(carAddRef, carId),newData )
      if(newData.active){
        let updateData = {
          carType: newData.carType,
          vehicleNumber: newData.vehicleNumber,
          vehicleMake: newData.vehicleMake,
          vehicleModel: newData.vehicleModel,
          other_info: newData.other_info,
          car_image:url,
          updateAt: new Date().getTime()
        };
        // carApproved is no longer RAISED from the app: the server's
        // mirrorActiveCar trigger copies it from the active /cars row, and an
        // admin approves cars in the portal. Lowering stays: a new active car
        // that is not approved takes the old car's approval away at once, also
        // while the server mirror is off (settings.activeCarMirrorEnabled);
        // the rules accept a lowering write at any time.
        if (newData.approved !== true) updateData.carApproved = false;
        await update(singleUserRef(auth.currentUser.uid),updateData);
        // Patch the acting client's cached users array so the vehicle fields
        // reflect immediately (no-op on mobile/RN where there is no IDB cache).
        patchUsersCacheUpsert(auth.currentUser.uid, updateData);
      }
      return { id: carId, ...newData };
    })
  };